import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import jobPostSlice from "./slices/jobPostSlice";
import userSlice from "./slices/userSlice";
import orderSlice from "./slices/orderSlice";
import payStackSlice from "./slices/payStackSlice";

const store = configureStore({
  reducer: {
    auth: authSlice,
    jobPost: jobPostSlice,
    user: userSlice,
    order: orderSlice,
    payStack: payStackSlice,
  },
});

export default store;

// INFO: Exporting auth actions and thunks
export {
  logout,
  switchRole,
  checkAndSwitchRoleByPath,
  openSignInModal, 
  closeSignInModal,
  handleSessionExpiration,
  endDataRefresh,
  startDataRefresh,
  updateAuth,
} from "./slices/authSlice";

export * from "./thunks/authThunks";
export * from "./thunks/jobPostThunks";
export * from "./thunks/userThunks";
export * from "./thunks/orderThunks";
export * from "./thunks/payStackThunks";
export * from "./thunks/threadThunks";